import type { WorkerCommand, WorkerEvent } from "./worker-protocol";
export class CaptureWorkerClient {
  private nextId = 1;
  private readonly pending = new Map<
    number,
    { resolve: (value: unknown) => void; reject: (error: Error) => void }
  >();
  constructor(
    private readonly worker: Worker,
    private readonly event: (event: WorkerEvent) => void,
  ) {
    worker.onmessage = ({ data }: MessageEvent<WorkerEvent>) => {
      if (data.type === "response") {
        const request = this.pending.get(data.requestId);
        if (!request) return;
        this.pending.delete(data.requestId);
        if (data.error)
          request.reject(
            Object.assign(new Error(data.error), { status: data.status }),
          );
        else request.resolve(data.value);
      } else this.event(data);
    };
    worker.onerror = () => {
      for (const request of this.pending.values())
        request.reject(
          new Error(
            "Локальное сохранение прервалось. Не закрывайте вкладку; проверьте сохранённую часть записи.",
          ),
        );
      this.pending.clear();
    };
  }
  call<T>(command: WorkerCommand, transfer: Transferable[] = []): Promise<T> {
    const requestId = this.nextId++;
    return new Promise((resolve, reject) => {
      this.pending.set(requestId, {
        resolve: (value) => resolve(value as T),
        reject,
      });
      try {
        this.worker.postMessage({ requestId, command }, transfer);
      } catch (error) {
        this.pending.delete(requestId);
        reject(error);
      }
    });
  }
  close(): void {
    this.worker.terminate();
    for (const request of this.pending.values())
      request.reject(new Error("Локальная запись закрыта"));
    this.pending.clear();
  }
}
